import api from './api';
import { useNotification } from '../contexts/NotificationContext';


export const send_otp = async (data) => {
    // let number = {"phone":"+919159862847"}
    // let number = {"value":"afraz@gmail.com"}
    let complete_phone = "+"
    if (!data["phone"].startsWith("+")){
         data["phone"] = complete_phone + data["phone"]
    }
  
    // console.log(data);

    try{
        const response = await api.post(`/user/otp_login`, data);
        // console.log(response)
        return response.data;
    }
    catch(error){
        throw new Error(error.response.data.detail)
    }
    

}

export const verify_otp = async (otp) => {
    try{
        const response = await api.post(`/user/verify_otp`, otp);
        // console.log("response => " , response.data);
        return response.data;
    }
    catch(error){
        // console.log("Error Here => " , error)
    }
    
}

export const login_with_password = async (data) => {
    try {
        const response = await api.post(`/user/login`, data);
        // console.log("Response From =>", response);
        return response.data;
    } catch (error) {

        if (error.response) {
            // console.log("Error response data:", error.response.data);
            throw new Error(error.response.data.detail || "Something went wrong");
        } else if (error.request) {
            // console.log("Request made but no response received:", error.request);
            throw new Error("No response from server. Please check your network or CORS setup.");
        } else {
            // console.log("Error setting up request:", error.message);
            throw new Error("Unexpected error: " + error.message);
        }
    }
};

export const signup = async (data) => {
    data["role"] = "super_user";
    let response;
    try{
        response = await api.post(`/user/signup`, data);
        return response.data;
    }
    catch(error){
        if(error.response){
            throw new Error(error.response.data.detail || "Something went wrong");
        }else {
            // console.log("Error setting up request:", error.message);
            throw new Error("Unexpected error: " + error.message);
        }
    }
    
}